import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo, Spinner } from "@/components/common";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, password });
            toast.success("Password updated. Please sign in.");
            nav("/login", { replace: true });
        } catch (err) {
            toast.error(formatApiError(err.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex min-h-screen flex-col bg-background">
            <div className="p-5"><Logo /></div>
            <div className="flex flex-1 items-center justify-center px-5 pb-16">
                <div className="w-full max-w-md rounded-3xl bg-card p-8 shadow-sm">
                    <h1 className="font-display text-3xl font-700 tracking-tight text-primary">Choose a new password</h1>
                    {!token ? (
                        <p className="mt-4 text-sm text-destructive">This reset link is invalid or missing a token.</p>
                    ) : (
                        <form onSubmit={submit} className="mt-6 space-y-4">
                            <div><Label>New password</Label><Input data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} className="mt-1.5" /></div>
                            <Button type="submit" disabled={loading} data-testid="reset-submit" className="w-full rounded-full bg-primary hover:bg-primary/90">
                                {loading ? <Spinner className="h-5 w-5 border-white/40 border-t-white" /> : "Update password"}
                            </Button>
                        </form>
                    )}
                    <p className="mt-6 text-center text-sm"><Link to="/login" className="text-accent hover:underline">Back to sign in</Link></p>
                </div>
            </div>
        </div>
    );
}
